import MovieCard from "./MovieCard"
import movieData from "../movieData.json"
import { Link } from "react-router-dom"

import { createBrowserHistory } from "history"

function MovieCollection(props) {
    const history = createBrowserHistory()

    const handleClick = () => {
        history.push(`?service=${props.streamingService}`)
    }

    let moviesArray = []

    if (props.streamingService) {
        moviesArray = movieData.filter((movie) => movie.whereToWatch).filter((movie) => movie.whereToWatch.includes(props.streamingService))
    } else {
        moviesArray = movieData.filter((movie) => movie.whereToWatch)
    }

    const movies = moviesArray.sort((movie1, movie2) => {
                                if (movie1.title < movie2.title) { return -1 }
                                if (movie1.title > movie2.title) { return 1 }
                                return 0
                            })
                            .map((movie) => {
                                return(
                                    <Link key={movie.title} to={`/movies/${movie.title}`} onClick={handleClick}>
                                        <MovieCard
                                            movie={movie} 
                                        />
                                    </Link>
                                )
                            })

    return (
        <div className="movie-collection">
            {movies}
        </div>
    )
}

export default MovieCollection
